module.exports = __webpack_public_path__ + "static/media/JetMinds6.b7e8d222.gif";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/JetMinds6.gif
// module id = 787
// module chunks = 20